import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { makeApiRequest } from '../axiosService/apiCall';
import { useNavigate } from "react-router-dom";

function Userincomehistory() {
    const [data, setData] = useState([]); // Stores filtered data
    const [originalData, setOriginalData] = useState([]); // Stores unfiltered data
    const [searchTerm, setSearchTerm] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [adminmlmid, setAdminmlmid] = useState("")
    const navigate = useNavigate();

    useEffect(() => {
        fetchUserData();
    }, []);

    const fetchUserData = async () => {
        try {
            let params = {
                url: `getuserslevelincomehistory`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log(response.
                // adminlevelincomehisory[0]._id, "response");

            if (response.status === true) {
                setAdminmlmid(response.
                    adminlevelincomehisory[0]._id)
                setData(response.userlevelincomehistory);
                setOriginalData(response.userlevelincomehistory); // Store original data for filtering
            } else {
                setData([]);
                setOriginalData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        setResetPaginationToggle(!resetPaginationToggle);
        // console.log('value', value)
        if (value) {
            const filteredResults = originalData.filter(item =>
                item.userEmail?.toLowerCase().includes(value)
            );

            setData(filteredResults);
        } else {
            setData(originalData);
        }
    };

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: true,
            width: '200px',
        },
        {
            name: 'Email',
            selector: row => row.userEmail || "N/A",
            sortable: true,
        },
        {
            name: 'Level Income History',
            cell: row => (
                <a href={`view-history?userId=${row._id}`}>
                    <button className='table-btn'>View History</button>
                </a>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '300px',

        }
    ];

    return (
        <div className='App'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className="custom-saled-order text-dark ms-3">
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user">User Level Income History</h3>
                            </div>

                            <div className='row'>
                                <div className='col-lg-12'>
                                    <div className='d-flex justify-content-between'>
                                        <input
                                            type="text"
                                            placeholder="Search by Email"
                                            value={searchTerm}
                                            onChange={handleSearch}
                                            className='form-search mb-4'
                                        />
                                        <a href={`view-history?adminId=${adminmlmid}`}>

                                            <button className='register-btn-spinner-1'>Admin Levelincome history</button>
                                        </a>

                                    </div>


                                    <div className='custom-datascroll'>
                                        <DataTable
                                            columns={columns}
                                            data={data} // ✅ Use filtered data here
                                            theme="solarized"
                                            defaultSortAsc={true}
                                            pagination
                                            paginationResetDefaultPage={resetPaginationToggle}
                                            highlightOnHover
                                            dense
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Userincomehistory;
